import { assignSealed } from "./utils/assignSealed";
export class Operation {
    constructor(name, options = {}) {
        this.name = name;
        assignSealed(this, options);
    }
}
//# sourceMappingURL=Operation.js.map